
const digest = 'c9e5ef29774f0b67e4682e8ea94f2dfeae8c068ab0453605734f4ccd1f40024c';
const classes = {"container":"_container_1p2sp_1","list":"_list_1p2sp_5","selected":"_selected_1p2sp_14","removeSelected":"_removeSelected_1p2sp_20"};
const css = `._container_1p2sp_1 {
  position: relative;
}

._list_1p2sp_5 {
  border: 1px solid #1452ac;
  border-radius: 30px;
  position: absolute;
  z-index: 999;
  width: 100%;
  background: #fff;
}

._selected_1p2sp_14 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

._removeSelected_1p2sp_20 {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  